import { Icon } from '#/components/Icon/Icon';
import { Text } from '#/components/Text/Text';
import { useI18n } from '#/i18n/hooks/useI18n';
import { colors } from '#/theme/theme';

export function ListingViewHeaderDoneInADayTag() {
  const { i18n } = useI18n();

  return (
    <Text style={{ display: 'inline-block', color: colors.brightPlum }}>
      <Icon name="hammer" size={18} /> {i18n('Done in a Day')}
    </Text>
  );
}
